<template>
  <div>
    <confirm ref="confirm"></confirm>
    <v-card class="orange lighten-5" elevation="3">
      <v-card-title class="white--text orange">Betaling</v-card-title>

      <v-row class="mt-0">
        <v-col cols="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>Status</v-list-item-subtitle>

              <PaymentStatus v-if="paymentStatusDefined()" :order="order" />
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>Transaksjon ID</v-list-item-subtitle>

              {{ payment.transaction_id }}
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="hasAvailableActions" cols="12">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>Handlinger</v-list-item-subtitle>

              <v-btn
                v-if="canCapture"
                class="mr-3"
                color="primary"
                small
                @click="confirmCapture"
                >Fullfør</v-btn
              >
              <v-btn
                v-if="canRelease"
                class="mr-3"
                color="error"
                small
                @click="confirmRelease"
                >Kanseller</v-btn
              >
              <v-btn v-if="canRefund" color="error" small @click="confirmRefund"
                >Tilbakebetal</v-btn
              >
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import PaymentStatus from "@/components/PaymentStatus";
import Confirm from "@/components/Confirm";
import backend from "@/backend";

export default {
  name: "PaymentDetails",
  components: {
    PaymentStatus,
    Confirm,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    payment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canCapture: function () {
      return this.availableActions.includes("capture");
    },
    canRefund: function () {
      return this.availableActions.includes("refund");
    },
    canRelease: function () {
      return this.availableActions.includes("release");
    },
    hasAvailableActions: function () {
      return this.availableActions.length > 0;
    },
    availableActions: function () {
      switch (this.payment.status) {
        case "preauth":
          return ["capture", "release"];
        case "confirmed":
          return ["refund"];
        default:
          return [];
      }
    },
  },
  methods: {
    paymentStatusDefined() {
      return typeof this.payment.status !== "undefined";
    },

    async confirmRefund() {
      if (
        await this.$refs.confirm.open(
          "Bekreft tilbakebetaling",
          "Er du sikker på at du vil tilbakebetale denne betalingen?",
          { color: "red" }
        )
      ) {
        await backend.put(
          `payments/${this.payment.id}/refund/`,
          {
            amount: this.payment.total,
          },
          {
            order: this.payment.order,
          }
        );

        this.$emit("update:payment");
      }
    },
    async confirmCapture() {
      if (
        await this.$refs.confirm.open(
          "Bekreft fullføring",
          "Er du sikker på at du vil fullføre denne betalingen?",
          { color: "green" }
        )
      ) {
        await backend.post(
          `payments/${this.payment.id}/capture/`,
          {},
          { order: this.payment.order }
        );

        this.$emit("update:payment");
      }
    },
    async confirmRelease() {
      if (
        await this.$refs.confirm.open(
          "Kanseller betaling",
          "Er du sikker på at du vil kansellere denne betalingen?",
          { color: "orange" }
        )
      ) {
        await backend.post(
          `payments/${this.payment.id}/release/`,
          {},
          { order: this.payment.order }
        );

        this.$emit("update:payment");
      }
    },
  },
};
</script>
